/**
* @ngdoc service
* @name common.service:DebugModalsService
* @description
* Support the logic for the debug component.
*/
(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('DebugModalsService', DebugModalsService);

    DebugModalsService.$inject = [
        'ngDialog',
        'MODALS'
    ];

    function DebugModalsService (
        ngDialog,
        MODALS
    ) {

        var _this = this;

        // _this.modals = [{
        //     template: 'dialog-success.template.html',
        //     className: 'ngdialog-theme-plain -order-cancel -order-cancel-confirmation',
        //     showClose: true,
        //     data: {
        //         title: inditex.text('myaccount_access_update_email'),
        //         message: inditex.text('myaccount_access_update_email_txt')
        //     }
        // }];

        var service =  {
            getModals:getModals,
            openModal: openModal
        };

        return service;

        /**
        * @ngdoc method
        * @name openModal
        * @methodOf common.service:DebugModalsService
        * @description
        * Open the given modal, looking for the template property.
        * @param {string} modal Modal object
        */
        function openModal(inputModal){

            var selectedModal = _.find(MODALS, function(modal){
                return ( (modal.alias && modal.alias == inputModal.alias) ||
                        (modal.template && modal.template == inputModal.template) || 
                        (modal.templateUrl && modal.templateUrl == inputModal.templateUrl));
            });

            if(selectedModal){
                ngDialog.open(selectedModal);    
            }
            
        }

        /**
        * @ngdoc method
        * @name getModals
        * @methodOf common.service:DebugModalsService
        * @description
        * Return the array of modals
        * @return {Array} Array of modals
        */
        function getModals(){
            return MODALS;
        }

    }

})();